import { setConfig } from "@justhome/common";

export const configureCommon = () =>
  setConfig({
    api: {
      core: {
        baseUrl: process.env.NEXT_PUBLIC_CORE_BASE_URL,
      },
    },
    logger: {
      service: "justhome",
      version: process.env.NEXT_PUBLIC_RELEASE_VERSION,
    },
  });
